export const imageStorage = (imageSrc) => {
  return `${process.env.NEXT_PUBLIC_STORAGE}/storage/${imageSrc}`
}
